/**
 * Returns a wrapper which calls 'func' not often than 'ms' (delay time)
 *
 * @param func {Function} function to trigger
 * @param ms {Number} delay in milliseconds
 * @returns {Function}
 */
export const debounce = (func, ms) => {
    let timer = null;

    return function(...args) {
        const onComplete = () => {
            func.apply(this, args);
            timer = null;
        };

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(onComplete, ms);
    };
};

/**
 * Gets all element of path after domain name
 * @returns {Array} - Array of elements
 */
export const parseUrlBySlash = () => {
    const data = [];
    if (window.location) {
        const pair = window.location.pathname.split('/');
        for (let param, i = 0; i < pair.length; i++) {
            param = pair[i];
            data[i] = param;
        }
    }
    return data;
};

export const getLocaleParams = () => {
    let cc;
    let lc;

    try {
        const urlMatch = window.location.pathname.match(/\/([\w]{2})\/([\w]{2})\//i);
        [, cc, lc] = urlMatch;
    } catch (err) {
        cc = 'us';
        lc = 'en';
        console.error(
            'An error occured. \nDefault locale params are used (us/en) instead. \nError: ',
            err,
        );
    }

    return { cc, lc };
};
